import MatchedMap from 'utilities/src/matchedMap';
import { FlyoutSizesEnum, type FlyoutSizesType } from '../types/_size';

const flyoutUlClasses = 'z-40 flex h-full items-center space-x-2';
const flyoutMainLinkClasses = 'flex h-10 items-center justify-center focus:outline-none [&_svg]:ml-2';
const flyoutSubUlClasses = 'absolute left-0 inline-block h-auto text-left';
const flyoutSubLiClasses = 'h-full';
const flyoutSubLinkClasses = 'block whitespace-nowrap p-4 pr-6';

const flyoutSizesLiClasses = new MatchedMap([
  [FlyoutSizesEnum.Small, 'text-xs xl:text-sm'],
  [FlyoutSizesEnum.Medium, 'py-4 text-base font-bold'],
]);

const headerCommonTheme = ({ size = 'Medium' }: { size?: FlyoutSizesType }) => ({
  flyoutUlClasses,
  flyoutMainLinkClasses,
  flyoutSubUlClasses,
  flyoutSubLiClasses,
  flyoutSubLinkClasses,
  flyoutSizesLiClasses: flyoutSizesLiClasses.get(FlyoutSizesEnum[size]),
});

export default headerCommonTheme;
